import Button from 'common/components/Button/Button';
import PageHeader from 'common/components/PageHeader/PageHeader';
import Table from 'common/components/Table/Table';
import AlertsContext from 'common/contexts/alerts';
import useAuth from 'common/contexts/auth';
import useRouter from 'common/hooks/use-router';
import useItem from 'common/hooks/useItem';
import useList from 'common/hooks/useList';
import React, {
  // eslint-disable-next-line comma-dangle
  useCallback, useContext, useEffect, useMemo
} from 'react';
import { useTranslation } from 'react-i18next';

const TaskTypes = () => {
  const { t } = useTranslation();
  const {
    fetchItems,
    items,
    isFetching,
    filters,
    setFilter,
    pageCount,
    setPageIndex,
    error,
    pageIndex,
    removeListItem,
  } = useList('task-types', { defaultFilters: {}, defaultSort: 'name:ASC', cachePrefix: 'tasktypes' });
  const {
    removeItem,
  } = useItem('task-types');

  const { push } = useRouter();
  const { isAdmin } = useAuth();

  const handleDelete = useCallback(async (id) => {
    removeListItem(id);
    await removeItem(id);
    fetchItems();
  }, [removeListItem, fetchItems, removeItem]);

  const { setAlert } = useContext(AlertsContext);

  useEffect(() => {
    if (error) {
      setAlert(error, 'danger');
    }
  }, [error, setAlert]);

  const columns = useMemo(() => [
    {
      Header: t('common.name'),
      filterName: 'name_contains',
      className: 'table-start',
      Cell: ({ row: { original: { id, name } } }) => (
        <>
          <div
            onClick={() => push(`/task-types/edit/${id}`)}
            className="crud-item-avatar"
          >
            <span>{name[0]}</span>
          </div>
          <span className="clickable" onClick={() => push(`/task-types/edit/${id}`)}>
            {name}
          </span>
        </>
      ),
    },
    {
      Header: t('common.actions'),
      className: 'table-actions',
      // eslint-disable-next-line
      Cell: ({ row: { original: { id } } }) => {
        if (!isAdmin) return null;

        return (
          <>
            <Button
              onClick={() => push(`/task-types/edit/${id}`)}
              icon="fa-pencil-alt"
              color="primary"
              transparent
            />
            <Button
              // eslint-disable-next-line react/prop-types
              onClick={() => handleDelete(id)}
              icon="fa-trash-alt"
              color="danger"
              confirm
              transparent
              confirmMessage={t('common.delete')}
            />
          </>
        );
      },
    },
  ], [t, push, handleDelete, isAdmin]);

  return (
    <>
      <PageHeader
        title={t('common.taskTypes')}
        link={{ url: '/task-types/add', icon: 'plus', label: t('common.add') }}
        subLink={{
          url: '/configure',
          icon: 'arrow-left',
          goBack: true,
          label: t('common.back'),
        }}
      />
      <section className="section list-page list-action">
        <Table
          data={items ?? []}
          columns={columns}
          isFetching={isFetching}
          pageCount={pageCount}
          filters={filters}
          setFilter={setFilter}
          setPageIndex={setPageIndex}
          pageIndex={pageIndex}
        />
      </section>
    </>
  );
};

export default TaskTypes;
